/**
 * URL-hash keys for the shelves feature's deep-linkable overlays, bound via
 * `useHashDialog` / `useHashParamDialog` (see `@/hooks/use-hash-dialog`).
 * Row-scoped overlays carry the entity id as a hash param (`#edit/5`).
 */
export const SHELVES_HASH = {
  /** `#create` — ShelfAddDialog (2-step create → QR). */
  create: 'create',
  /** `#edit/<id>` — ShelfEditDialog editing a specific shelf. */
  edit: 'edit',
  /** `#delete/<id>` — single-shelf delete confirmation. */
  delete: 'delete',
  /** `#bulk-delete` — bulk delete confirmation (action bar). */
  bulkDelete: 'bulk-delete'
} as const;

export type ShelvesHashKey = (typeof SHELVES_HASH)[keyof typeof SHELVES_HASH];
